import { useState } from 'react';
import { Box, HStack, Icon, IconButton, Link, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { LuSparkles, LuX } from 'react-icons/lu';
import { useFeatureGate } from '@/hooks';
import { FeatureFlags } from '@/lib/feature-flag-constants';
import { ExternalUrls } from '@/lib/url-constants';

const ALPHA_BANNER_DISMISSED_KEY = 'cohaven_alpha_banner_dismissed';

export function AlphaBanner() {
    const isEnabled = useFeatureGate(FeatureFlags.ALPHA_BANNER);
    const [dismissed, setDismissed] = useState(
        () => localStorage.getItem(ALPHA_BANNER_DISMISSED_KEY) === 'true'
    );

    if (!isEnabled || dismissed) {
        return null;
    }

    const handleDismiss = () => {
        localStorage.setItem(ALPHA_BANNER_DISMISSED_KEY, 'true');
        setDismissed(true);
    };

    // Gold text on a gold tint rather than white on solid gold: white on
    // gold.500 sits around 2.5:1, well under AA for text this small.
    return (
        <Box
            bg="gold.subtle"
            color="gold.fg"
            px={{ base: 3, md: 4 }}
            py={1.5}
            textAlign="center"
            position="relative"
        >
            <HStack gap={2} justify="center" align="center">
                <Icon as={LuSparkles} boxSize={3.5} flexShrink={0} />
                <Text fontSize={{ base: 'xs', md: 'sm' }} fontWeight="medium">
                    <FormattedMessage
                        id="f7d8a3b2-5c4e-42a7-9b1c-3d8e5f6a7b9c"
                        defaultMessage="Now in limited alpha. Hit any issues? <link>Let us know</link>."
                        values={{
                            link: (chunks) => (
                                <Link
                                    href={`mailto:${ExternalUrls.SUPPORT_EMAIL}`}
                                    color="gold.fg"
                                    textDecoration="underline"
                                    fontWeight="semibold"
                                    _hover={{ color: 'gold.fg', opacity: 0.85 }}
                                >
                                    {chunks}
                                </Link>
                            ),
                        }}
                    />
                </Text>
            </HStack>
            <IconButton
                aria-label="Dismiss banner"
                size="xs"
                variant="ghost"
                color="gold.fg"
                position="absolute"
                right={2}
                top="50%"
                transform="translateY(-50%)"
                _hover={{ bg: 'gold.wash' }}
                onClick={handleDismiss}
            >
                <Icon as={LuX} boxSize={3.5} />
            </IconButton>
        </Box>
    );
}
